/* eslint-disable react-hooks/exhaustive-deps */
import '../App.css';
import React from 'react';
// import { WsContext } from '../App'
import { pack } from 'msgpackr';
import { write, useSnap } from '../store'
import { ref } from 'valtio'
import Webcam from "react-webcam";
import toast from 'react-hot-toast';
import {
  validateAudioTrack,
  getValidAudioDevice,
  hasAudioCapability,
  monitorTrackState,
} from '../utils/audioDeviceValidation';


// let chunks = [] // must be on with experimental
let recorder
let canvasCtx
let requestRef
let trackStateCleanup

function Rec() {
    // const ws = React.useContext(WsContext);
    const read = useSnap()
    const ws = read.ws
    // const webcamRef = React.useRef()
    const webcamWRef = React.useRef()
    const screenRef = React.useRef()
    const canvasRef = React.useRef()
    const [hideWebcam, setHideWebcam] = React.useState(false)
    const [vWidth, setvWidth] = React.useState(1)
    const [vHeight, setvHeight] = React.useState(1)
    const [webcamStream, setWebcamStream] = React.useState()
    const [canvasStream, setCanvasStream] = React.useState()
    const [isVideoOnly, setIsVideoOnly] = React.useState(false)
    // const [screenStream, setScreanStream] = React.useState()




    const handleWMedia = React.useCallback(function handleWMedia(stream) {
        setWebcamStream(stream)
        // console.log(stream)
    }, [])

    /**
     * Handle device change events during recording
     */
    const handleDeviceChange = React.useCallback(async () => {
        if (!webcamStream) {
            return;
        }

        try {
            const audioTracks = webcamStream.getAudioTracks();
            if (audioTracks.length === 0) {
                return;
            }

            const currentTrack = audioTracks[0];

            // Check if current device still has audio capability
            const currentDeviceId = read.currentAudioDeviceId || read.activeMic;
            const hasAudio = await hasAudioCapability(currentDeviceId);

            if (!hasAudio) {
                // Try to find alternative device
                const validDeviceId = await getValidAudioDevice();
                if (validDeviceId && validDeviceId !== currentDeviceId) {
                    toast.success("Switched to alternative audio device", {
                        duration: 3000,
                    });
                    write.currentAudioDeviceId = validDeviceId;
                } else if (!validDeviceId) {
                    // No alternative device available
                    toast.warning("No audio device available. Recording video only.", {
                        duration: 5000,
                    });
                    setIsVideoOnly(true);
                }
            }
        } catch (error) {
            console.error('Error handling device change:', error);
        }
    }, [webcamStream, read.currentAudioDeviceId, read.activeMic]);

    /**
     * Handle track state changes during recording
     */
    const handleTrackStateChange = React.useCallback((stateChange) => {
        const { type } = stateChange;

        if (type === 'ended') {
            toast.warning("Audio device disconnected. Recording video only.", {
                duration: 5000,
            });
            setIsVideoOnly(true);
        } else if (type === 'mute') {
            toast.warning("Microphone muted. Recording video only.", {
                duration: 5000,
            });
            setIsVideoOnly(true);
        }
    }, []);



    React.useEffect(() => {
        canvasCtx = canvasRef.current.getContext('2d');

        if (webcamStream) {
            // Validate stream creation and audio tracks
            const audioTracks = webcamStream.getAudioTracks();
            if (audioTracks.length === 0) {
                toast.error("No audio track found in stream", {
                    duration: 5000,
                });
                setIsVideoOnly(true);
            } else {
                const audioTrack = audioTracks[0];
                
                // Validate audio track state
                if (!validateAudioTrack(audioTrack)) {
                    toast.warning("Audio track is not valid. Recording video only.", {
                        duration: 5000,
                    });
                    setIsVideoOnly(true);
                }

                // Setup track state monitoring
                if (trackStateCleanup) {
                    trackStateCleanup();
                }
                trackStateCleanup = monitorTrackState(audioTrack, handleTrackStateChange);
            }

            // webcamRef.current.srcObject = webcamStream
            // console.log('read.sStream', read.sStream)
            read.sStream && (screenRef.current.srcObject = read.sStream)
            const vTracks = webcamStream.getVideoTracks()[0]
            // console.log(vTracks, '🍀🍀🍀')
            vTracks.addEventListener("ended", () => {
                write.page = 'CAMMICOFF'
            });
            const { height, width } = vTracks.getSettings()
            let multiplier
            if (read.OS === 'PC') {
                multiplier = 30
            } else if (read.OS === 'iOS') {
                multiplier = 20
            } else {
                multiplier = 30
            }

            const isMobile = read.OS === 'iOS' || read.OS === 'Android';
            setvWidth(isMobile ? 640 : (width ? ~~((width * multiplier) / 100) : 1280));
            setvHeight(isMobile ? 480 : (height ? ~~((height * multiplier) / 100) : 720));

            const targetFPS = isMobile ? 10 : 20;
            const interval = 1000 / targetFPS;
            let lastDrawTime = 0;


            const drawFrame = (currentTime) => {
                if (currentTime - lastDrawTime >= interval) {
                    if (webcamWRef.current && webcamWRef.current.video && webcamWRef.current.video.readyState === 4) {
                        canvasCtx.save();
                        canvasCtx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);

                        // Draw webcam
                        canvasCtx.drawImage(webcamWRef.current.video, 0, 0, canvasRef.current.width, canvasRef.current.height);

                        // Draw screen share overlay if present
                        if (screenRef.current && screenRef.current.srcObject) {
                            canvasCtx.globalCompositeOperation = "source-over";
                            canvasCtx.drawImage(screenRef.current, 0, 150, canvasRef.current.width / 2.5, canvasRef.current.height / 3.5);
                        }

                        canvasCtx.restore();
                        lastDrawTime = currentTime;
                    }
                }
                requestRef = requestAnimationFrame(drawFrame);
            };

            requestRef = requestAnimationFrame(drawFrame);


            // console.log(webcamStream.getVideoTracks()[0].getSettings(), width, height , canvasRef.current.width, canvasRef.current.height)


            const fps = isMobile ? 10 : 20
            // console.log('FPS', fps)
            const canvasStream = canvasRef.current.captureStream(fps);
            const audio = webcamStream.getTracks().find(el => el.kind === 'audio');
            
            // Only add audio track if it exists and is valid
            if (audio && validateAudioTrack(audio)) {
                canvasStream.addTrack(audio)
            }
            
            setCanvasStream(canvasStream)
            write.canvasStreamStore = ref(canvasStream)

            // Listen for device changes
            navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);

            return () => {
                navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
            };
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [webcamStream, handleDeviceChange, handleTrackStateChange]);

    // console.log(`vWidth`, vWidth, vHeight)

    function mR() {
        //random number between 1 and 10000
        const validator = Math.floor(Math.random() * (10000 - 1 + 1)) + 1;
        console.log('🍬🍬🍬 recorder renewed')
        let options
        if (MediaRecorder.isTypeSupported('video/webm; codecs=h264')) { //!h264 and why not?
            options = { mimeType: 'video/webm; codecs=h264' };
        } else if (MediaRecorder.isTypeSupported('video/webm; codecs=vp9')) {
            options = { mimeType: 'video/webm; codecs=vp9' };
        } else if (MediaRecorder.isTypeSupported('video/webm; codecs=vp8')) {
            options = { mimeType: 'video/webm; codecs=vp8' };
        } else if (MediaRecorder.isTypeSupported('video/mp4; codecs=avc1')) {
            options = { mimeType: 'video/mp4; codecs=avc1' };
        } else if (MediaRecorder.isTypeSupported('video/x-matroska; codecs=avc1')) {
            options = { mimeType: 'video/x-matroska; codecs=avc1' };
        } else {
            options = { mimeType: 'video/mp4' };
        }
        console.log(options, 'OPTIONS')
        recorder = new MediaRecorder(canvasStream, options);
        write.recorder = ref(recorder) // we want to use the recoer in other places


        recorder.ondataavailable = async (e) => {
            // chunks.push(e.data);
            // console.log('there is a chunk', e.data , e.data.size, recorder.state)
            //random number between 1 an 1000
            // const random = Math.floor(Math.random() * (1000 - 1 + 1)) + 1;
            // console.log('❓❓', validator)
            const arbuf = await e.data.arrayBuffer()
            const recordingType = isVideoOnly ? 'video-only' : 'audio-video';
            e.data.size && ws.send(pack({ type: 'REC', data: arbuf, options, validator, recordingType }))
        }
        recorder.start(200) //! production must be on
    }



    React.useEffect(() => {
        let timer1
        if (canvasStream && !read.recorder) { // !read.recorder re new the instance for speaking section as it doesn't record with 1 instance.

            // setTimeout(() => {
            mR()
            // }, 1000);
            write.mR = ref(mR) //make it global
            // console.log(mR, '🎙️🎙️🎙️')
            timer1 = setTimeout(() => {
                recorder.stop()
                cancelAnimationFrame(requestRef)
                console.log('🔚🔚🔚🔚🔚')
                ws.send(pack({ type: 'REC_FINISHED', format: 'ALL' }))
                ws.close()
            }, 7200000);
        }
        return () => {
            clearTimeout(timer1);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canvasStream]);


    React.useEffect(() => {
        return () => {
            cancelAnimationFrame(requestRef); // to ensure that the inerval is stopped.
            if (trackStateCleanup) {
                trackStateCleanup();
            }
            navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
        };
    }, [handleDeviceChange]);

    //experimental SAVING MP4 LOCALLY TO COMPARE WITH THE SERVER
    // React.useEffect(() => {
    //     if (read.currentQuestion > read.totalQuestions) {
    //         let blob = new Blob(chunks, { type: 'video/mp4' })
    //         console.log(`blob`, blob)
    //         const file = new File([blob], "1.mp4", { type: "video/mp4" });
    //         const url = URL.createObjectURL(file)
    //         console.log(file, url)
    //         const tempLink = document.createElement('a');
    //         tempLink.href = url;
    //         tempLink.setAttribute('download', 'filename.mp4');
    //         tempLink.click();
    //     }
    // }, [read.currentQuestion, read.totalQuestions]);
    //experimental

    React.useEffect(() => {
        if (read.currentQuestion > read.totalQuestions) {
            requestRef && cancelAnimationFrame(requestRef)
        }
    }, [read.currentQuestion, read.totalQuestions]);

    return (
        <div className="App absolute top-0 left-0 z-0">

            <Webcam
                ref={webcamWRef}
                // onClick={() => setHideWebcam(true)}
                className={`w-42 h-24 rounded-br-full ${hideWebcam && 'hidden'}`}
                audio={true}
                muted={true}
                onUserMedia={(e) => handleWMedia(e)}
                audioConstraints={{
                    deviceId: read.activeMic ? read.activeMic : undefined
                }}
                videoConstraints={{
                    width: (read.OS === 'iOS' || read.OS === 'Android') ? 640 : 1280,
                    height: (read.OS === 'iOS' || read.OS === 'Android') ? 480 : 720,
                    facingMode: "user",
                    deviceId: read.activeWebcam ? read.activeWebcam : undefined,
                }}
            />

            {/* {
                hideWebcam ? <span onClick={() => setHideWebcam(true)}>🔲</span> : <span onClick={() => setHideWebcam(true)} className=' absolute right-0 top-0 text-xs'>❌</span>
            } */}

            {/* <video muted ref={screenRef} style={{ width: 300, height: 182, background: 'red', display: 'none' }} autoPlay /> */}
            <video className='w-1 invisible' muted ref={screenRef} autoPlay />
            {/* <video muted ref={screenRef} style={{width : 50}} autoPlay /> */}
            <canvas className='hidden w-1' width={vWidth} height={vHeight} ref={canvasRef} />
            {/* <canvas ref={canvasRef} className='w-28' width={vWidth} height={vHeight} />         */}
        </div>
    );
}

export default Rec;